import { RePasswordContainer } from "../../containers/RegisterSystem/RePasswordContainer";

export function RePasswordPage() {

    return (
        <RePasswordContainer />
    );

}